import cartModel from './cartModel';

export const getGALinker = function getCartGALinker(joinWith = '&') {
  if (
    !window.ga
    || !window.ga.getAll
    || !window.ga.getAll()
    || !window.ga.getAll()[0]
  ) {
    return '';
  }
  return joinWith + window.ga.getAll()[0].get('linkerParam');
};

export const getReChargeProps = function getCartReChargeProps(token = '') {
  return `&cart_token=${token}`;
};

export const getReChargeCheckoutPayload = (cartData) => {
  const { user = {} } = window;
  const { email = '' } = user;

  return {
    cart: {
      items: [
        ...cartData.items.map(item => ({
          product_id: item.product_id,
          properties: {
            ...(item.properties || {}),
          },
          quantity: item.quantity,
          variant_id: item.variant_id,
        })),
      ],
      ...(cartData.note ? { note: cartData.note } : {}),
      ...(cartData.attributes ? { attributes: cartData.attributes } : {}),
    },

    ...(email ? { email } : {}),
  };
};

export const buildInputs = ({ form, payload }) => {
  // Build input fields for key, value pairs
  Object.keys(payload).forEach((key) => {
    const input = document.createElement('input');
    input.setAttribute('type', 'hidden');
    input.setAttribute('name', key);
    input.setAttribute(
      'value',
      typeof payload[key] === 'object'
        ? JSON.stringify(payload[key])
        : payload[key],
    );
    form.appendChild(input);
  });
};

export const buildForm = ({ payload, url }) => {
  // Build a virtual form
  const form = document.createElement('form');
  form.setAttribute('method', 'post');
  form.setAttribute('action', url);
  form.style.display = 'none';
  buildInputs({ form, payload });
  return form;
};

export const onCheckoutClick = function onCartCheckoutClick(ev) {
  const { token } = cartModel.getState();
  ev.preventDefault();

  const url = this.getAttribute('href')
    + getReChargeProps(token)
    + getGALinker();

  if (url) {
    const payload = getReChargeCheckoutPayload(cartModel.getState());

    const form = buildForm({ payload, url });
    document.body.appendChild(form);
    form.submit();
  }
};
